import { QRCode as QRCodeAD, type QRCodeProps } from 'antd';
import { forwardRef, useId, useImperativeHandle } from 'react';
import { downloadBlob } from 'common/utils';

const getQrCodeAsBlob = async ({ qrCodeId }: { qrCodeId: string }) => {
  const canvas = document.querySelector(`[id="${qrCodeId}"]`)?.querySelector<HTMLCanvasElement>('canvas');

  if (!canvas) {
    return null;
  }

  return new Promise<Blob | null>((resolve) => {
    canvas.toBlob(resolve, 'image/png');
  });
};

const downloadQrCode = async ({ fileName = 'QRCode.png', qrCodeId }: { fileName?: string; qrCodeId: string }) => {
  const finalFileName = `${fileName}.png`;

  const blob = await getQrCodeAsBlob({ qrCodeId });
  if (blob) {
    downloadBlob(blob, finalFileName);
  }
};

export type QrCodeRef = {
  download: (fileName?: { fileName?: string }) => void;
};

type P = {
  id?: string;
  isLoading?: boolean;
} & QRCodeProps;

// eslint-disable-next-line @typescript-eslint/naming-convention -- TODO: we want use this case
const QRCode = forwardRef<QrCodeRef, P>(({ isLoading, value, ...props }, ref) => {
  const id = useId();

  useImperativeHandle(ref, () => ({
    async download({ fileName }: { fileName?: string } = {}) {
      await downloadQrCode({ fileName, qrCodeId: id });
    },
  }));

  return (
    <div id={id}>
      <QRCodeAD color="black" status={isLoading ? 'loading' : undefined} value={value} {...props} />
    </div>
  );
});

QRCode.displayName = 'QRCode';

export default QRCode;
